import { createAsyncThunk } from "@reduxjs/toolkit";
import { myDesignService } from "../../services";

export const fetchMyDesigns = createAsyncThunk(
  'myDesigns/fetchMyDesigns',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.fetchMyDesigns(
      infos?.hasOwnProperty('offset') ? infos.offset : 'default',
      infos?.hasOwnProperty('limit') ? infos.limit : 'default',
      infos?.hasOwnProperty('reset') ? infos.reset : false,
    )
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return {
      response,
      concat: !(infos?.offset === 'default' && infos?.limit === 'default'),
      reset: infos?.hasOwnProperty('reset') ? infos.reset : false,
    };
  }
)

export const fetchSingleMyDesign = createAsyncThunk(
  'myDesigns/fetchSingleMyDesign',
  async (id, { rejectWithValue }) => {
    const response = await myDesignService.fetchSingleMyDesign(id)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const fetchZones = createAsyncThunk(
  'myDesigns/fetchZones',
  async (frameId, { rejectWithValue }) => {
    const response = await myDesignService.fetchZones(frameId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const fetchStats = createAsyncThunk(
  'myDesigns/fetchStats',
  async (frameId, { rejectWithValue }) => {
    const response = await myDesignService.fetchStats(frameId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updatePlaylistActivation = createAsyncThunk(
  'myDesigns/updatePlaylistActivation',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updatePlaylistActivation(infos.zoneId, infos.value)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return infos;
  }
)

export const fetchPlaylist = createAsyncThunk(
  'myDesigns/fetchPlaylist',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.fetchPlaylist(infos.zoneId, infos.token)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const fetchSelectedZoneContent = createAsyncThunk(
  'myDesigns/fetchSelectedZoneContent',
  async (zoneId, { rejectWithValue }) => {
    const response = await myDesignService.fetchSelectedZoneContent(zoneId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updateFolderId = createAsyncThunk(
  'myDesigns/updateFolderId',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updateFolderId(infos.externalId, infos.label, infos.frameId)
    if (!response) {
      return rejectWithValue('offline')
    }
    if (response.status >= 300)
      return rejectWithValue('An error has occured, try again later')
    return infos.externalId;
  }
)

export const requestCampaign = createAsyncThunk(
  'myDesigns/requestCampaign',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.requestCampaign(infos.campaignForm, infos.targetId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const fetchCampaigns = createAsyncThunk(
  'myDesigns/fetchCampaigns',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.fetchCampaigns(infos.frameId, infos.targetId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updateRedirect = createAsyncThunk(
  'myDesigns/updateRedirect',
  async (item, { rejectWithValue }) => {
    const response = await myDesignService.updateRedirect(item.infos, item.newUrl, item.title, item.description, item.message)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return { res: response, infos: item.infos, newUrl: item.newUrl };
  }
)

export const updateTimezone = createAsyncThunk(
  'myDesigns/updateTimezone',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updateTimezone(infos.frameId, infos.targetId, infos.timeZone, infos.targets)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response
  }
)

export const sendNotification = createAsyncThunk(
  'myDesigns/sendNotification',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.sendNotification(infos.frameId, infos.frameName, infos.label, infos.zoneName)
    if (!response)
      return rejectWithValue('offline')
    if (response.status >= 300)
      return rejectWithValue('An error has occured, try again later')
    return response
  }
)

export const createMyDesign = createAsyncThunk(
  'myDesigns/createMyDesign',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.createMyDesign(infos.folderId, infos.designName, infos.confidentiality)
    if (!response)
      return rejectWithValue('offline')
    if (response.status >= 300)
      return rejectWithValue('An error has occured, try again later')
    return response
  }
)

export const fetchScheduledCampaigns = createAsyncThunk(
  'myDesigns/fetchScheduledCampaigns',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.fetchScheduledCampaigns(infos.frameId, infos.targetId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const createCampaign = createAsyncThunk(
  'myDesigns/createCampaign',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.createCampaign(infos.campaign, infos.target, infos.files)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updateCampaign = createAsyncThunk(
  'myDesigns/updateCampaign',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updateCampaign(infos.campaign, infos.target, infos.files, infos.campaignId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updateZoneLabel = createAsyncThunk(
  'myDesigns/updateZoneLabel',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updateZoneLabel(infos.targetUrl, infos.frameId, infos.target, infos.zoneId, infos.label)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const updateMyDesignPlayerMode = createAsyncThunk(
  'myDesigns/updateMyDesignPlayerMode',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updateMyDesignPlayerMode(infos.zoneId, infos.value)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return {value: infos.value, zoneId: infos.zoneId};
  }
)

export const updateTarget = createAsyncThunk(
  'myDesigns/updateTarget',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.updateTarget(infos.targetId, infos.target, infos.targetLabel)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const duplicateTargets = createAsyncThunk(
  'myDesigns/duplicateTargets',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.duplicateTargets(infos.frameId, infos.target, infos.targetId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    infos.cb(response.target)
    return response;
  }
)

export const deleteZone = createAsyncThunk(
  'myDesigns/deleteZone',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.deleteZone(infos.frameId, infos.zone, infos.target)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return infos.zone;
  }
)

export const createZones = createAsyncThunk(
  'myDesigns/createZones',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.createZones(infos.frameId, infos.zones, infos.target, infos.files)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const deleteTarget = createAsyncThunk(
  'myDesigns/deleteTarget',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.deleteTarget(infos.frameId, infos.target)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return infos.target;
  }
)

export const createTargets = createAsyncThunk(
  'myDesigns/createTargets',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.createTargets(infos.frameId, infos.targets)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    infos.cb(response[0])
    return response;
  }
)

export const associateImageMyDesign = createAsyncThunk(
  'myDesigns/associateImageMyDesign',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.associateImageMyDesign(infos.files, infos.frameId)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return response;
  }
)

export const addOrRemoveElementInPlaylist = createAsyncThunk(
  'myDesigns/addOrRemoveElementInPlaylist',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.addOrRemoveElementInPlaylist(infos.zoneId, infos.elementId, infos.activated, infos.item)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return {activated: infos.activated, item: infos.item};
  }
)

export const savePlaylistPosition = createAsyncThunk(
  'myDesigns/savePlaylistPosition',
  async (infos, { rejectWithValue }) => {
    const response = await myDesignService.savePlaylistPosition(infos.zoneId, infos.elementId, infos.newPosition)
    if (!response)
      return rejectWithValue('offline')
    if (response.status < 300)
      return rejectWithValue('An error has occured, try again later')
    return infos.finalItems;
  }
)